(function () {
  'use strict';

  var cfg = window.RSVLTS_CART_SYNC;
  if (!cfg || !cfg.enabled) return;

  var KEY = cfg.storageKey;

  // Cart is pre-fetched and kept in memory so the submit handler can write
  // to localStorage synchronously (no async fetch during page navigation,
  // which Safari cancels before it completes).
  var cachedCartItems = [];

  function refreshCartCache() {
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        cachedCartItems = cart.items || [];
      })
      .catch(function () {});
  }

  // Synchronous write — completes before the browser starts navigating away.
  function saveGuestCart() {
    if (cachedCartItems.length === 0) return;
    var backup = cachedCartItems.map(function (item) {
      return {
        id: item.variant_id,
        quantity: item.quantity,
        properties: item.properties || {}
      };
    });
    localStorage.setItem(KEY, JSON.stringify(backup));
  }

  function syncGuestCart() {
    var raw = localStorage.getItem(KEY);
    if (!raw) return;

    localStorage.removeItem(KEY);

    var guestItems;
    try { guestItems = JSON.parse(raw); } catch (e) { return; }
    if (!guestItems || guestItems.length === 0) return;

    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (currentCart) {
        var currentQty = {};
        (currentCart.items || []).forEach(function (item) {
          currentQty[item.variant_id] = item.quantity;
        });

        var toAdd = [];
        guestItems.forEach(function (item) {
          var existingQty = currentQty[item.id] || 0;
          if (item.quantity > existingQty) {
            toAdd.push({
              id: item.id,
              quantity: item.quantity - existingQty,
              properties: item.properties
            });
          }
        });

        if (toAdd.length === 0) return;

        return fetch('/cart/add.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/javascript'
          },
          body: JSON.stringify({ items: toAdd })
        });
      })
      .then(function (res) {
        if (!res) return;
        document.dispatchEvent(new CustomEvent('cart:update:complete', { detail: {} }));
        document.dispatchEvent(new CustomEvent('cart:refresh'));
      })
      .catch(function (e) {
        console.error('[cart-sync] sync failed:', e);
      });
  }

  document.addEventListener('DOMContentLoaded', function () {
    // Pre-fetch cart immediately so cache is ready before user clicks login.
    refreshCartCache();

    // Keep cache fresh whenever the cart changes.
    document.addEventListener('cart:update:complete', refreshCartCache);
    document.addEventListener('cart:add:complete', refreshCartCache);

    var loginForm = document.getElementById('login-desktop');
    if (loginForm) {
      loginForm.addEventListener('submit', saveGuestCart);
    }

    if (cfg.customerLoggedIn) {
      syncGuestCart();
    }
  });
})();
